import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUpRightFromSquare} from "@fortawesome/free-solid-svg-icons";

export const Footer = () => {
  return (
    <footer>
      <div className="footerWrap">
        <div className="organizerWrap">
          <h3>《主催》</h3>
          <p>音羽電機工業株式会社、日刊工業新聞社</p>
        </div>
        <div className="infoWrap">
          <p>《個人情報の取り扱いについて》</p>
          <div>
            <p>
              ご登録いただいた会社名、氏名、住所、電話番号、メールアドレスなどの個人情報は、音羽電機工業株式会社および日刊工業新聞社が共同利用し、展示会・セミナー・サービス・商品等、各種ご案内を送らせていただくことを目的に利用させていただきます。
              <br />
              なお、個人情報の取り扱いについては、下記の各社ウェブサイトより、ご確認ください。
            </p>
            <div className="linkWrap">
              <a href="https://www.otowadenki.co.jp/privacypolicy/" target="_blank" className="anchor">
                ●音羽電機工業株式会社
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </a>
              <a href="https://www.nikkan.co.jp/pages/privacy" target="_blank" className="anchor">
                ●日刊工業新聞社
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </a>
            </div>
            <p>
              また、ご案内の宛先変更または配信停止をご希望の際には、下記までご連絡くださいますようお願い申し上げます。
            </p>
            <p>日刊工業新聞社 事業推進部「雷セミナー」係</p>
            <p>
              E-mail：
              <a href="mailto:kaminari@media.nikkan.co.jp" className="anchor">
                kaminari@media.nikkan.co.jp
              </a>
            </p>
          </div>
        </div>

        <div className="infoWrap">
          <p>〔セミナーに関するお問い合わせ・お申し込み先〕</p>
          <div>
            <p>
              日刊工業新聞社　事業推進部「雷セミナー」係
              <br />
              TEL：03-5644-7227
              <br />
              〒103-8548 東京都中央区日本橋小網町14-1
              <br />
              E-mail：
              <a href="mailto:kaminari@media.nikkan.co.jp" className="anchor">
                kaminari@media.nikkan.co.jp
              </a>
            </p>
          </div>
        </div>

        <div className="infoWrap">
          <p>〔雷に関するお問い合わせ先〕</p>
          <div>
            <p>
              音羽電機工業株式会社　営業本部
              <br />
              TEL：0120-31-0108
              <br />
              お問い合わせ：
              <a href="https://www.otowadenki.co.jp/contact/" target="_blank" className="anchor">
                https://www.otowadenki.co.jp/contact/
              </a>
            </p>
          </div>
        </div>
      </div>
      <p className="credit">© 2026 THE NIKKAN KOGYO SHIMBUN,LTD. All Rights Reserved.</p>
    </footer>
  );
};
